// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__X0-ex","fullView":"styles_fullView__3pI6c"};